import useContentfulPreview from 'hooks/useContentfulPreview';
import MetaData from 'contentful/meta_data';
import EvergreenContent from './evergreen_content';

const EvergreenShow = ({ content, products }) => {
  const { fields } = useContentfulPreview(content);

  const { evergreenContent, seoTitle, seoDescription, canonicalUrl } = fields;

  return (
    <div className="mb-20 m-mb-0">
      <MetaData
        title={seoTitle}
        description={seoDescription}
        canonicalUrl={canonicalUrl}
      />

      <EvergreenContent
        content={evergreenContent}
        productReference={products}
      />
    </div>
  );
};

export default EvergreenShow;
